const Accordion = (() => {
	const DOM = {};

	const cacheDOM = () => {
		DOM.acc = document.getElementsByClassName("accordion-header");
	};

	const openclose = function() {
		this.classList.toggle("active");
		var panel = this.nextElementSibling;
		if (panel.style.display === "block") {
			panel.style.display = "none";
		} else {
			panel.style.display = "block";
		}
	};

	const eventListener = () => {
		for (let i = 0; i < DOM.acc.length; i++) {
			DOM.acc[i].addEventListener("click", openclose);
		}
	};

	const init = () => {
		cacheDOM();
		eventListener();
	};

	return {
		init,
	};
})();

export default Accordion;
